import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { FAVORITES_AND_WATCHLIST_STATES } from 'contexts/CruiseSearchContext/constants';
import { INITIAL_TRACKING_BRAND, TRACKING_INTERACTION, TYPES_BANNER } from './Constants';
import {
	utagAffirmBanner,
	utagBannerLoad,
	utagCloseComparisonClicked,
	utagComparePageLoad,
	utagComparePageWatchlistAndSelectDateButton,
	utagCompareRemoveCruise,
	utagEvent,
	utagExploreItineraryLinkClicked,
	utagFavoritesLimitReached,
	utagFavoritesSignInPanelDisplayed,
	utagFavoritesWatchlistCardClicked,
	utagFavoritesWatchlistClicked,
	utagGuestClicked,
	utagItineraryPanel,
	utagMyOffersFilter,
	utagOfferApplied,
	utagOfferPillClicked,
	utagPagination,
	utagPortClicked,
	utagRatingTooltip,
	utagRatingViewMore,
	utagShowOfferPill,
	utagSortClicked,
	utagTargetedOffersLoad,
	utagTargetedOffersLogin,
} from './functions';
import { createInitialPageTrack } from './utils';

export const AnalyticsContext = React.createContext({});

const AnalyticsContextProvider = ({ brand, children }) => {
	const setLoyaltyUser = (loyaltyUser) => {
		setContextState({
			...initialState,
			loyaltyUser,
		});
	};

	const getEventFavorites = (userFavorites, cruiseId, stateFavoriteButton) => {
		let eventFavoriteButton = null;
		const { FAVORITES_AND_WATCHLIST: { CLICK_ADDED, CLICK_REMOVED } = {} } = TRACKING_INTERACTION;
		const { SELECTED, UNSELECTED } = FAVORITES_AND_WATCHLIST_STATES;

		if (!userFavorites.includes(cruiseId)) {
			if (stateFavoriteButton === SELECTED) {
				eventFavoriteButton = CLICK_ADDED;
			}
		} else {
			if (stateFavoriteButton === UNSELECTED) {
				eventFavoriteButton = CLICK_REMOVED;
			}
		}
		return eventFavoriteButton;
	};

	const getInteractionTooltip = (buttonClicked) => {
		return TRACKING_INTERACTION.FAVORITES_AND_WATCHLIST.CLICK_SEARCH_DASHBOARD.replace('{0}', buttonClicked);
	};

	const categorizeFavoritesAndWatchlistUserEvent = (label, listEvents) => {
		const eventToCreate = listEvents.filter((item) => item.toLowerCase().includes(label.toLowerCase()));
		return eventToCreate?.[0];
	};

	const categorizeWatchlistEvent = (status) => {
		const { FAVORITES_AND_WATCHLIST: { CLICK_ADDED, CLICK_REMOVED } = {} } = TRACKING_INTERACTION;
		const { SELECTED, UNSELECTED } = FAVORITES_AND_WATCHLIST_STATES;
		let eventToSend = null;
		if (status === SELECTED) {
			eventToSend = CLICK_ADDED;
		} else if (status === UNSELECTED) {
			eventToSend = CLICK_REMOVED;
		}
		return eventToSend;
	};

	const updateTracking = (initialTracking) => {
		setContextState({
			...initialState,
			tracking: initialTracking,
		});
	};

	const trackingInit = INITIAL_TRACKING_BRAND[brand];

	const initialState = {
		utagAffirmBanner,
		utagOfferApplied,
		utagTargetedOffersLogin,
		utagTargetedOffersLoad,
		utagFavoritesWatchlistClicked,
		utagFavoritesWatchlistCardClicked,
		utagFavoritesLimitReached,
		setLoyaltyUser,
		utagMyOffersFilter,
		utagBannerLoad,
		loyaltyUser: '',
		initialTrackPageEvent: false,
		tracking: trackingInit,
		getEventFavorites,
		getInteractionTooltip,
		categorizeFavoritesAndWatchlistUserEvent,
		categorizeWatchlistEvent,
		utagEvent,
		createInitialPageTrack,
		updateTracking,
		utagShowOfferPill,
		utagPagination,
		utagSortClicked,
		utagOfferPillClicked,
		utagItineraryPanel,
		utagRatingTooltip,
		utagRatingViewMore,
		utagFavoritesSignInPanelDisplayed,
		constants: {
			TYPES_BANNER,
		},
		utagPortClicked,
		utagGuestClicked,
		utagComparePageLoad,
		utagCloseComparisonClicked,
		utagCompareRemoveCruise,
		utagExploreItineraryLinkClicked,
		utagComparePageWatchlistAndSelectDateButton,
	};

	const [contextState, setContextState] = useState(initialState);

	return <AnalyticsContext.Provider value={contextState}>{children}</AnalyticsContext.Provider>;
};

AnalyticsContextProvider.propTypes = {
	children: PropTypes.node,
	brand: PropTypes.string,
};

export default AnalyticsContextProvider;
